import { Observable } from 'rxjs';
import { SessionService } from '../_services/session/session.service';
import { BaseComponent } from '../components/base/base.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';
import ISite from '../_interfaces/ISite';

@Component({
  selector: 'app-delete-base',
  template: '',
  imports: [ToastModule],
})
export abstract class DeleteBase<T> extends BaseComponent {
  @Input('affectedSite')
  public affectedSite: ISite = undefined;

  @Input('payload')
  public payload: T = undefined;

  @Input('onDelete')
  public onDelete = () => {};

  constructor(
    public session: SessionService,
    public confirm: ConfirmationService,
    public messageService: MessageService,
    public translate: TranslateService
  ) {
    super(session);
  }

  abstract delete(): Observable<any>;
  abstract getResourceName(): string;

  public deleteMessageError() {
    this.showMessage(
      'error',
      this.translate.instant(
        `MESSAGES.ERRORS.DELETE.${this.getResourceName()}.SUMMARY`
      ),
      this.translate.instant(
        `MESSAGES.ERRORS.DELETE.${this.getResourceName()}.DETAIL`
      )
    );
  }

  public deleteMessageSuccess() {
    this.showMessage(
      'success',
      this.translate.instant(
        `MESSAGES.SUCCESS.DELETE.${this.getResourceName()}.SUMMARY`
      ),
      this.translate.instant(
        `MESSAGES.SUCCESS.DELETE.${this.getResourceName()}.DETAIL`
      )
    );
  }

  private showMessage(severity: string, summary: string, detail: string) {
    this.messageService.add({
      severity,
      summary,
      detail,
    });
  }

  async execute(): Promise<void> {
    this.confirm.confirm({
      rejectButtonStyleClass:
        'virtualcenter-button virtualcenter-button--primary',
      acceptButtonStyleClass:
        'virtualcenter-button virtualcenter-button--danger',
      rejectButtonProps: {
        size: 'small',
      },
      acceptButtonProps: {
        size: 'small',
      },

      header: this.translate.instant(
        `CONFIRM.DELETE.${this.getResourceName()}.HEADER`
      ),
      message: this.translate.instant(
        `CONFIRM.DELETE.${this.getResourceName()}.MESSAGE`
      ),
      accept: () => {
        this.delete().subscribe({
          next: () => {
            this.deleteMessageSuccess();
            this.onDelete();
          },
          error: () => {
            this.deleteMessageError();
          },
        });
      },
    });
  }
}
